<template>
  <div>
    <div class="container" style="margin-top: 50px;">
      <h1 align="center">Create Account</h1>
      <div class="row">
        <div class="col-lg-4">
          <picture-input
            ref="pictureInput"
            width="100"
            height="100"
            margin="16"
            size="10"
            button-class="btn"
            :prefill="photo_url"
            :custom-strings="{ upload: '<h1>Bummer!</h1>', drag: 'Drag and drop your photo here'}"
            @prefill="onPrefillPhoto"
            @change="onChangePhoto"
          ></picture-input>
          <b-form-group label="User Name">
            <b-form-input v-model="name" placeholder="Enter your name" :disabled="name_disable"></b-form-input>
          </b-form-group>
          <b-form-group label="Email Address">
            <b-form-input
              v-model="email"
              placeholder="Enter your email address"
              :disabled="email_disable"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Comapny Name">
            <b-form-input v-model="company" placeholder="Enter your company name"></b-form-input>
          </b-form-group>
          <b-form-group label="Comapny Website URL">
            <b-form-input v-model="company_website" placeholder="Enter your company website url"></b-form-input>
          </b-form-group>

          <!-- <b-form-file v-model="photo" accept=".jpg, .png, .gif, .jpeg"></b-form-file> -->
          <!-- <b-img
            :src="photo_url"
            fluid
            alt="Responsive image"
            rounded
            style="width:100px; height:100px;"
          ></b-img>-->
        </div>
        <div class="col-lg-8">
          <b-form-group label="Your business type">
            <b-form-radio-group id="radio-group-2" v-model="user_type" name="radio-sub-component">
              <b-form-radio value="manufacturer">Manufacturer</b-form-radio>
              <b-form-radio value="distributor">Distributor</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <MapCountry :countries_selected="countries"></MapCountry>
        </div>
      </div>

      <b-row style="margin-top: 20px;">
        <div class="col-4">
          <!-- <b-button size="sm" @click="toBack()">Prev</b-button> -->
        </div>

        <div class="col-4" style="text-align:center">
          <!-- <b-button size="sm">Default Button</b-button> -->
        </div>
        <div class="col-4" style="text-align:right">
          <b-button size="sm" @click="toPortfolio()">Next</b-button>
        </div>
      </b-row>
      <!-- <b-navbar type="light" variant="light">
        <b-navbar-nav>
          <b-nav-item left>
            <base-button type="primary" size="sm"><< Prev</base-button>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item right>
            <base-button type="primary" size="sm">Next >></base-button>
          </b-nav-item>
        </b-navbar-nav>
      </b-navbar>-->
    </div>
  </div>
</template>
<script>
import MapCountry from "./components/MapCountry";
import PictureInput from "vue-picture-input";
import axios from "axios";

export default {
  name: "components",
  components: {
    MapCountry,
    PictureInput,
  },
  data() {
    return {
      chart: null,
      user_type: "manufacturer",
      photo_url: "",
      photo_updated: false,
      name: "",
      name_disable: false,
      email: "",
      name_email: false,
      company: "",
      company_website: "",
      state: true,
      countries: [],
    };
  },
  created() {
    console.log(JSON.stringify(this.$route.query));
    let vm = this;
    if (JSON.stringify(this.$route.query) != "{}") {
      //google | linkedin | phone
      axios
        .post(
          "http://zorion.alpha-innomed.com:4040/api/auth/oauth",
          this.$route.query
        )
        .then(function (response) {
          // handle success
          console.log(response);
          console.log(response.data);
          vm.$store.dispatch("clearToken");
          vm.$store.dispatch("clearUser");
          vm.$store.dispatch("storeToken", response.data.token);
          vm.$store.dispatch("storeUser", response.data.user);

          console.log(vm.$store.state.user);
          if (vm.$store.state.user.fullname != "") {
            vm.name = vm.$store.state.user.fullname;
            vm.name_disable = true;
          }
          if (vm.$store.state.user.email != "") {
            vm.email = vm.$store.state.user.email;
            vm.email_disable = true;
          }
          vm.photo_url = vm.$store.state.user.picture_url;
          if (vm.$store.state.user.user_type != "") {
            vm.user_type = vm.$store.state.user.user_type;
          }
          if (vm.$store.state.user.company_name != "") {
            vm.company = vm.$store.state.user.company_name;
          }
          if (vm.$store.state.user.company_website != "") {
            vm.company_website = vm.$store.state.user.company_website;
          }
          if (vm.$store.state.user.countries != []) {
            vm.countries = vm.$store.state.user.countries;
          }
        })
        .catch(function (error) {
          // handle error
          console.log(error);
          vm.$store.dispatch("clearToken");
          vm.$store.dispatch("clearUser");
          vm.$router.push({ name: "register" });
        })
        .then(function () {
          // always executed
        });
    }
  },
  mounted() {},
  methods: {
    saveAccount() {
      console.log(this.countries);
    },
    toPortfolio() {
      let vm = this;
      let updated_user = this.$store.state.user;
      updated_user.user_type = this.user_type;
      updated_user.picture_url = this.photo_url;
      updated_user.fullname = this.name;
      updated_user.email = this.email;
      updated_user.company_name = this.company;
      updated_user.company_website = this.company_website;
      updated_user.countries = this.countries;

      if (this.photo_updated) {
        const formData = new FormData();
        formData.append("profile", this.image_file);
        // Post the form, just make sure to set the 'Content-Type' header
        axios
          .post(
            "http://zorion.alpha-innomed.com:4040/api/user/upload_photo",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(function (response) {
              updated_user.picture_url = response.data.filename;
              vm.$store.dispatch("storeUser", updated_user);
          });
      } else {
        this.$store.dispatch("storeUser", updated_user);
      }

      axios
        .post(
          "http://zorion.alpha-innomed.com:4040/api/user/update",
          updated_user
        )
        .then(function (response) {
          // handle success
          window.location.href = "#/portfolio";
        })
        .catch(function (error) {
          // handle error
          console.log(error);
          vm.$store.dispatch("clearToken");
          vm.$store.dispatch("clearUser");
          vm.$router.push({ name: "register" });
        });
    },
    async onChangePhoto(image) {
      console.log("New picture selected!");
      console.log(this.$refs.pictureInput.file);
      if (image) {
        // this.image = await fetch(image).then(res => res.blob());;
        this.image_file = this.$refs.pictureInput.file;
        // console.log(this.image);
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
      this.photo_updated = true;
    },
    onPrefillPhoto() {
      // console.log("onprefill photo");
      // console.log(this.photo_url);
      this.image = this.photo_url;
    },
  },
};
</script>
